import { Switch } from 'react-router-dom'
import AccountancyList from './AccountancyList'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_TROUBLESHOOT } from 'app-support/permissions/Permissions'
import DefaultRevenueList from '../accountancyDefaults/components/DefaultRevenueList'
import { accountancyErrorList, accountancyRoute, troubleshootRoute } from 'routes/routeNames'
import AccountancyErrorList from '../ErrorListContainer/components/AccountancyErrorList'

const enhance = withRegionSwitchHandler('/troubleshoot')

const TroubleShootContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_TROUBLESHOOT} exact path={accountancyRoute} component={AccountancyList} />
    <PermissionRoute permission={PERMISSION_TROUBLESHOOT} exact path={accountancyErrorList} component={AccountancyErrorList} />
    <PermissionRoute permission={PERMISSION_TROUBLESHOOT} exact path={troubleshootRoute} component={DefaultRevenueList} />
  </Switch>
)

export default enhance(TroubleShootContainer)
